// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import { store } from './store/store'

// element-ui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import 'babel-polyfill'
// import echarts from 'echarts'
// import preview from 'vue-photo-preview'
// import 'vue-photo-preview/dist/skin.css'
import './assets/common/al_font/iconfont.css'
import './assets/common.css'
import config from './utils/constant'
// import Print from 'vue-print-nb'
// import Print from '@/api/print'
import axios from 'axios'
import * as echarts from 'echarts'
import App from './App'
import router from './router'
import 'babel-polyfill'
// Vue.use(Print)
// Vue.use(preview)
Vue.use(ElementUI)
// Vue.use(echarts)
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$CFG = config
Vue.prototype.$echarts = echarts
/* eslint-disable no-new */

// 路由判断登录 根据路由配置文件的参数
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requireAuth)) { // 判断该路由是否需要登录权限
    if (sessionStorage.getItem('token') !== '' && sessionStorage.getItem('token') !== null && sessionStorage.getItem('token') !== undefined) { // 判断当前的token是否存在 ； 登录存入的token
      next()
    } else {
      next({
        path: '/'
      })
    }
  } else {
    next()
  }
})
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js